export default "__VITE_ASSET__BB1l9yjd__"